import React from "react";
import ShiftScheduler from "@/components/app/ShiftScheduler";
import { CalendarDays } from "lucide-react";

export default function MyShifts() {
  return (
    <div className="space-y-5 max-w-6xl" data-testid="my-shifts-page">
      <div>
        <span className="label-overline flex items-center gap-1.5">
          <CalendarDays className="w-3 h-3" /> Roster
        </span>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-1">My Shifts</h1>
        <p className="text-sm text-zinc-500 mt-2 max-w-2xl">
          Your assigned shifts for the week. Use the arrows to navigate to upcoming or past weeks.
        </p>
      </div>
      <ShiftScheduler />
    </div>
  );
}
